import {
  V2ListPaymentCreditsForAccountApiArg,
  useV2ListPaymentCreditsForAccountQuery,
} from "@generated";
import type { PaymentCredit } from "../types";

export interface UsePaymentCreditsListArgs {
  page?: V2ListPaymentCreditsForAccountApiArg["page"];
  filter?: V2ListPaymentCreditsForAccountApiArg["filter"];
}

export interface PaymentCreditsListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const usePaymentCreditsList = ({
  page,
  filter,
}: UsePaymentCreditsListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListPaymentCreditsForAccountQuery(
      { page, filter },
      // Refetch on remount (e.g. returning from Edit) so saves are reflected.
      { refetchOnMountOrArgChange: true }
    );

  const rows: PaymentCredit[] = (data?.data ?? []).map((pc: any) => ({
    id: String(pc.id),
    paymentSource: pc.attributes?.["payment-source"] ?? "",
    description: pc.attributes?.description ?? "",
    criteria: pc.attributes?.criteria ?? "",
  }));

  const pageMeta: PaymentCreditsListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default usePaymentCreditsList;
